// seso expander
if(typeof SesoExpander === 'undefined'){
    const SesoExpander = class {
        constructor(selector, accOption) {
            this.el = {};
            this.el.wrapper = selector instanceof HTMLElement
                ? selector
                : (
                    document.getElementById(selector) ||
                    document.querySelector(selector)
                );
            this.el.expander = this.el.wrapper ? this.el.wrapper.querySelectorAll('.expander')
                : [];
            this.el.expanderController = this.el.wrapper ? this.el.wrapper.querySelectorAll('.expander-controller')
                : [];
            this.el.expanderContentInner = this.el.wrapper ? this.el.wrapper.querySelectorAll('.expander-content > .inner')
                : [];

            this.params = {
                openClass: 'is-open',
                isAccordion: undefined,
                dataAttrExpandableHeight: 'data-expander-height'
            };

            this.params.isAccordion = accOption ? accOption
                : false;

            this.initExpander();
        }

        initExpander() {
            var _this = this;

            // manage resize
            window.addEventListener('resize', function() {
                _this.detectExpanderHeights();
            });

            this.detectExpanderHeights();

            // react on expander controller click
            for (var i = 0; i < this.el.expanderController.length; i++) {
                this.el.expanderController[i].addEventListener('click', (event) => {
                    event.preventDefault();
                    let clicked = event.target.closest('.expander');

                    if(this.params.isAccordion) {
                        // accordion
                        if (_this.el.wrapper.classList.contains(_this.params.openClass)) {
                            // if any expander is open
                            if(clicked.classList.contains(_this.params.openClass)) {
                                // if clicked is open -> close clicked
                                _this.closeExpander(clicked);
                            } else {
                                // not the open expander was clicked
                                _this.closeAllExpandersAndOpenClicked(clicked);
                            }
                        } else {
                            // all expanders are closed -> open clicked
                            _this.openExpander(clicked);
                        }
                    } else if(clicked.classList.contains(_this.params.openClass)) {
                        // simple expander
                        // close clicked
                        _this.closeExpander(clicked);
                    } else {
                        // if clicked is NOT open -> open clicked
                        _this.openExpander(clicked);
                    }
                });
            }
        }

        detectExpanderHeights () {
            var expHeight, exp;

            for (var i = 0; i < this.el.expanderContentInner.length; i++) {
                exp = this.el.expanderContentInner[i].closest('.expander');
                expHeight = this.el.expanderContentInner[i].clientHeight;

                this.el.expanderContentInner[i].setAttribute(this.params.dataAttrExpandableHeight, expHeight);

                if(exp.classList.contains(this.params.openClass)) {
                    exp.querySelector('.expander-content').style.maxHeight = expHeight + 'px';
                }
            }
        }

        closeExpander(element) {
            var expanderContent = element.closest('.expander').querySelector('.expander-content');

            element.classList.remove(this.params.openClass);
            expanderContent.style.maxHeight = '0px';

            if(this.params.isAccordion) {
                this.el.wrapper.classList.remove(this.params.openClass);
            }
        }

        openExpander(element) {
            var expanderContent = element.closest('.expander').querySelector('.expander-content');

            element.classList.add(this.params.openClass);
            expanderContent.style.maxHeight = (expanderContent.querySelector('.inner').getAttribute(this.params.dataAttrExpandableHeight)) + 'px';

            if(this.params.isAccordion) {
                this.el.wrapper.classList.add(this.params.openClass);

                setTimeout(function() {
                    // position elemtent on top of viewport
                    element.scrollIntoView({behavior: "smooth"});
                }, 400);
            }
        }

        closeAllExpandersAndOpenClicked(clicked) {
            var _this = this;
            for (var j = 0; j < this.el.expander.length; j++) {
                // close all other expander
                this.el.expander[j].classList.remove(this.params.openClass);
                this.el.expander[j].closest('.expander').querySelector('.expander-content').style.maxHeight = '0px';

                // open clicked
                if(j == (this.el.expander.length - 1)) {
                    setTimeout(function() {
                        _this.openExpander(clicked);
                    }, 200);
                }
            }
        }
    }

    if (typeof window !== 'undefined') {
        window.SesoExpander = SesoExpander;
    }

    window.addEventListener('load', (event) => {
        // expander single level
        document.querySelectorAll('a1-fragment[name="expander-single-level"]').forEach(function (fragment) {
            // params: selector, optional: accordionOption
            window.a1ExpanderSingleLevel = new SesoExpander(fragment.querySelector('.expander-wrapper'));
        });
    });
}
